import script from "./SignInForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignInForm.vue?vue&type=script&setup=true&lang=js"

import "./SignInForm.vue?vue&type=style&index=0&id=4295e830&lang=scss"

const __exports__ = script;

export default __exports__